import { MutationTree } from 'vuex';
import { PeriodState, Period } from './state';

const mutations: MutationTree<PeriodState> = {
  SET_CURRENT_PERIOD_START_DATE(state, startDate: string) {
    state.periodStartDate = startDate;
  },
  SET_USER_PERIODS(state, periods: Period[]) {
    state.periods = periods;
  },
  SET_USER_CURRENT_PERIOD(state, currentPeriod: Period) {
    state.currentPeriod = currentPeriod;
  },
  SET_LOADING_PERIODS(state, isLoading: boolean) {
    state.isLoadingPeriod = isLoading;
  },
};

export default mutations;
